import * as i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { getCurrentLang } from './helpers/locales';

const defaultNS = 'translation';
const fallbackNS = [
	'menu',
	'workSchedule',
	'login',
	'workingLog',
	'workingAdmin',
	'approval',
	'commonText',
	'companySetting',
	'workFlexible',
	'workPlace',
	'board',
	'workGroup',
	'holidayWorkLog',
	'filters',
	'resetPassword',
	'companyAuthority',
	'userVacation',
	'userPregnancy',
	'holiday',
	'workSetting',
	'userDashboard',
	'restManage',
	'memberList',
	'notification',
	'attendance',
	'assumedWorkRequest',
	'workType',
	'workStandard',
	'leaveCarryOver',
	'annualLeavePlan',
	'annualLeavePromotion',
	'workSchedulePattern',
	'shiftManagement',
	'annualLeaveException',
	'compensationLeave',
	'commonCodeSetting',
	'privacyPolicy',
	'companySatoryLeave'
];
const ns = [defaultNS, ...fallbackNS];

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		lng: getCurrentLang(),
		fallbackLng:'ko', // 기본값
		debug: false,
		returnObjects: false,
		returnEmptyString: false,
		ns,
		defaultNS,
		fallbackNS,
		backend: {
			loadPath: `/locales/{{lng}}/{{ns}}.json?ts=${Date.now()}`,
		},
		compatibilityJSON: 'v3',
		interpolation: {
			escapeValue: false,
		},
		react: {
			useSuspense: false,
			transSupportBasicHtmlNodes: true,
		},
		saveMissing: false,
		missingKeyHandler: false,
		saveMissingTo: 'current',
		parseMissingKeyHandler: (key) => key,
		reloadResources: true,
		cleanCode: true,
		partialBundledLanguages: false,
	});

export default i18n;
